import { selector } from "recoil"
import { Category } from "../models/Category"
import api from "../services/api"
import { areeMySixtemaState } from "../utils/hooks"
import { userState } from "./auth"

export const categoryAll = selector({
    key: 'categoryAll',
    get: async ({get}) => {
        
        let category: Category[] = []
        const rv = await api.getAllCategory()
        if (!rv) return category

        return rv
    }
})

export const categoryOfUser = selector({
    key: 'categoryOfUser',
    get: async ({get}) => {
        const user = get(userState)
        let areeArray: string[] = get(areeMySixtemaState)
        let aree: string = ''
        if (areeArray && areeArray.length > 0) {
            areeArray.forEach(x => {
                aree += x+';'
            })
        }
        let category: Category[] = []
        const rv = await api.getCategoryByAree(aree)
        if (!rv) return category
        rv.forEach(x => {
            if (user?.setting?.notifications?.indexOf(x.id.toString()) !== -1)
                x.isSelected = true
        })
        return rv
    }
})